var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "pa-2",
      attrs: { cols: "6", sm: "4", md: "3", lg: "2", xl: "2" },
    },
    [
      _c(
        "v-card",
        {
          style: {
            border: _vm.collection.collected
              ? "3px solid #03a9f4 !important"
              : "unset",
          },
          attrs: {
            dark:
              _vm.collection.state !== "W" &&
              _vm.collection.state !== "K" &&
              _vm.collection.state !== "L",
            color: _vm.state_color,
            elevation: "3",
          },
        },
        [
          _c(
            "v-container",
            { staticClass: "py-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pa-0", attrs: { cols: "9" } }, [
                    _c("span", { staticClass: "font-weight-medium pl-2" }, [
                      _vm._v(" " + _vm._s(_vm.collection.state_display) + " "),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-img", {
            staticClass: "card-img-top",
            staticStyle: { cursor: "pointer" },
            attrs: { src: _vm.collection.image_url },
            on: { click: _vm.onShowImage },
          }),
          _c("v-card-title", { staticClass: "pa-2 py-0" }, [
            _vm.collection.purchase
              ? _c("span", [_vm._v("Сбор №" + _vm._s(_vm.collection.number))])
              : _c("span", [_vm._v("Не в закупке")]),
          ]),
          _c(
            "v-container",
            { staticClass: "py-0 px-2 mt-n1", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "start", justify: "center" } },
                [
                  _vm.collection.collected
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "light-blue text-center",
                              attrs: { elevation: "3", dark: "" },
                            },
                            [_vm._v(" Собран ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.collection.prepayment_value > 0
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "primary text-center pa-1",
                              staticStyle: {
                                "line-height": "17px",
                                cursor: "pointer",
                              },
                              attrs: { elevation: "3", dark: "" },
                              on: { click: _vm.onShowCheck },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "Предоплата поставщику " +
                                    _vm._s(_vm.collection.prepayment_value) +
                                    "₽"
                                ),
                              ]),
                              _c("div", { staticClass: "caption mt-n1" }, [
                                _vm._v("(Показать чек)"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.collection.state_comment
                    ? _c(
                        "v-col",
                        { staticClass: "py-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "secondary text-center",
                              attrs: { elevation: "3", dark: "" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.collection.state_comment) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-subtitle",
            {
              staticClass: "px-2 pt-0 pb-1 subtitle-1",
              staticStyle: { "line-height": "1.2" },
            },
            [
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.collection.description)),
              ]),
              _vm._l(_vm.positions_info, function (position_info, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "font-weight-medium",
                    staticStyle: { "font-size": "14px" },
                  },
                  [_vm._v(_vm._s(position_info) + " ")]
                )
              }),
            ],
            2
          ),
          _c("v-divider", { staticClass: "mx-2" }),
          !_vm.opened_link.additional.hide_price
            ? _c(
                "div",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0 pt-1 pl-2" },
                    [
                      _vm._v(" " + _vm._s(_vm.collection.trade_price) + " "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            position: "relative",
                            bottom: "1px",
                            right: "6px",
                          },
                          attrs: { small: "" },
                        },
                        [_vm._v(_vm._s(_vm.icon_rub))]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            position: "relative",
                            bottom: "2px",
                            right: "5px",
                          },
                          attrs: { size: "13" },
                        },
                        [_vm._v(_vm._s(_vm.icon_mul))]
                      ),
                      _c(
                        "span",
                        { class: { count: _vm.collection_count > 1 } },
                        [_vm._v(_vm._s(_vm.collection_count) + "шт.")]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.collection.prepayment_value > 0,
                              expression: "collection.prepayment_value > 0",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            " - " +
                              _vm._s(_vm.collection.prepayment_value) +
                              " "
                          ),
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                position: "relative",
                                bottom: "1px",
                                right: "6px",
                              },
                              attrs: { small: "" },
                            },
                            [_vm._v(_vm._s(_vm.icon_rub))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-title",
                    { staticClass: "px-2 py-0 mt-n1" },
                    [
                      _vm._v(" = " + _vm._s(_vm.total_price) + " "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            position: "relative",
                            right: "4px",
                            bottom: "0.5px",
                          },
                          attrs: { size: "19.5" },
                        },
                        [_vm._v(_vm._s(_vm.icon_rub))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("v-card-title", { staticClass: "px-2" }, [
                    _vm._v(" Итого "),
                    _c(
                      "span",
                      {
                        staticClass: "ml-2",
                        class: { count: _vm.collection_count > 1 },
                      },
                      [_vm._v(_vm._s(_vm.collection_count) + "шт.")]
                    ),
                  ]),
                ],
                1
              ),
          _c("v-divider", { staticClass: "mx-2" }),
          _c(
            "v-container",
            { staticClass: "px-4 pb-2 pt-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _vm.collection.collected
                    ? _c(
                        "v-col",
                        {
                          staticClass: "pa-0 px-1 pt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "secondary caption text-none",
                              attrs: {
                                width: "100%",
                                loading: _vm.toggle_collected_loading,
                                rounded: "",
                              },
                              on: { click: _vm.onToggleCollected },
                            },
                            [_vm._v(" НЕ СОБРАН ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        {
                          staticClass: "pa-0 px-1 pt-2 text-center",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary caption text-none",
                              attrs: {
                                width: "100%",
                                loading: _vm.toggle_collected_loading,
                                rounded: "",
                              },
                              on: { click: _vm.onToggleCollected },
                            },
                            [_vm._v(" СОБРАН ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }